import React, { useCallback, useEffect, useState } from "react";
import { MODULE_API } from "../../../../apis";
import * as Style from "./styles/Asset-Listing";
import tableimg from "../../../../assets/images/big/camera.png";
import Loader from "../../../../components/styled-components/loader/loader";
import NewLoader from "../../../../components/styled-components/loader/NewLoader";
import { Modal, Form, Button } from "antd";
import swal from "sweetalert";
import { Link, useHistory } from "react-router-dom";
import addIcon from "../../../../assets/SVGs/android-chrome-512x512.png";
import addIcon1 from "../../../../assets/images/DeathModuleNew/addIcon.png";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import moment from "moment";
import {
  saveActiveProperty,
  saveAllProperties,
} from "../../../../redux/slices/propertiesSlice";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
function AssetListing(props) {
  const [allProperties, setAllProperties] = useState([]);
  const [activeItem, setActiveItem] = useState("");
  const [activeRoom, setActiveRoom] = useState();
  const [allItems, setAllItems] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isModal, setModal] = useState(false);
  const [showItems, setShowItems] = useState(false);
  const [showItemAdd, setShowItemAdd] = useState(false);
  const history = useHistory();

  const { propertiesInfo, roomsInfo, itemsInfo } = useSelector(
    (state) => state.rootReducer
  );
  const dispatch = useDispatch();
  const updateInventory = useCallback((item) => {}, []);
  const updateProperties = useCallback(() => {
    airplaneReport();
  }, []);

  const { module } = useParams();

  React.useEffect(() => {
    airplaneReport();
  }, []);
  let propertiesList = [];
  let roomsList = [];
  let rooms = [];

  async function airplaneReport() {
    try {
      setIsLoading(true);
      setAllProperties([]);
      let airplane = await MODULE_API.fetchItems({
        moduleName: module,
        pageNum: 1,
        limit: 10,
        body: {},
      });
      setIsLoading(false);
      console.log("new report");

      // propertiesList=airplane&&
      propertiesList =
        airplane &&
        airplane.records.map((properties) => ({
          id: properties.id,
          Owner: properties.Owner,
          module: properties.module,
          type: properties.type ? properties.type : 0,
          subType: properties.subType ? properties.subType : 0,
          img:
            properties.image
              ? properties.image
              : tableimg,
          name: properties["Name of Asset"],
          total: properties.total ? properties.total : 0,
          "Account Type/Titled": properties["Account Type/Titled"],
          "Account Number": properties["Account Number"] ? properties["Account Number"] :null ,
          "Held Where": properties["Held Where"] ? properties["Held Where"] :null ,
          "Rate of Return": properties["Static"] ? properties["Static"] :null ,
          "Cost Basis Date": properties["Cost Basis Date"] ? properties["Cost Basis Date"] :null ,
          "Cost Basis": properties["Cost Basis"] ? properties["Cost Basis"] :null ,
          "Monetary Value": properties["Monetary Value"] ? properties["Monetary Value"] :null ,
        }));
      setAllProperties(propertiesList);
      // dispatch(saveAllProperties(propertiesList));
    } catch (error) {
      console.log("e ", error);
    }
  }

  function handleDelete(event, item, type) {
    console.log(
      "event",
      event,
      "item",
      item,
      "active Item=>",
      activeItem,
      activeRoom
    );
    swal({
      title: "Are you sure?",
      text: "Are you sure that you want to Delete this Property?",
      icon: "warning",
      dangerMode: true,
      buttons: true,
    }).then(async (doDelete) => {
      setIsLoading(true);
      doDelete &&
        (await MODULE_API.removeClientModule({
          clientModules: [item.id],
        }));
      if (type == "property") {
        updateProperties();
        setActiveItem("");
        return;
      } else if (type == "room") {
        await MODULE_API.getRecordTotal(activeItem.id, {
          attributes: ["total"],
        });
        setAllItems("");
        setShowItems(false);
        setShowItemAdd(false);
      } else {
        await MODULE_API.getRecordTotal(activeRoom, {
          attributes: ["currentValue"],
        });
        await MODULE_API.getRecordTotal(activeItem.id, {
          attributes: ["total"],
        });
      }
      updateInventory(activeItem);
    });
  }
  function handleEdit(event, item, type) {
    console.log(
      "event",
      event,
      "item",
      item,
      "active Item=>",
      activeItem,
      activeRoom
    );
    history.push(`/assets_new/attributes/${item.module}/${item.id}`);
    // history.push("/assets_edit/" + item.id);
    // `/assets_new/attributes/${record.module}/${record.id}`
    // swal({
    //     title: "Are you sure?",
    //     text: "Are you sure that you want to Delete this Property?",
    //     icon: "warning",
    //     dangerMode: true,
    //     buttons: true,
    // }).then(async (doDelete) => {
    //     setIsLoading(true);
    //     doDelete &&
    //         (await MODULE_API.removeClientModule({
    //             clientModules: [item.id],
    //         }));
    //     if (type == "property") {
    //         updateProperties();
    //         setActiveItem("");
    //         return;
    //     } else if (type == "room") {
    //         await MODULE_API.getRecordTotal(activeItem.id, {
    //             attributes: ["total"],
    //         });
    //         setAllItems("");
    //         setShowItems(false);
    //         setShowItemAdd(false);
    //     } else {
    //         await MODULE_API.getRecordTotal(activeRoom, {
    //             attributes: ["currentValue"],
    //         });
    //         await MODULE_API.getRecordTotal(activeItem.id, {
    //             attributes: ["total"],
    //         });
    //     }
    //     updateInventory(activeItem);
    // });
  }
  function handleView(event, item,) {
    history.push(`/assets_new/attributes/${item.module}/${item.id}/view`);

  }
  function moneyFormatter(value) {
    const formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    });

    let result = formatter.format(value);
    console.log("Money :: ", result);
    return result;
  }
  const capitalizeFirstLetter = (string) => {
    return string.replace(/\b\w/g, (char) => char.toUpperCase());
  };
  return (
    <div style={{position:"relative"}}>
      <Style.Main >
        <Style.Cards
          style={{
            borderBottom:
            allProperties && allProperties.length > 0 ? "1px solid #F0F0F0" : "none",
          }}>
          <Style.SubCards
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}>
            <Style.CardsHead>
              <h3
                style={{
                  fontWeight: "bold",
                  fontFamily: "Poppins",
                  fontSize: "20px",
                }}>
                {module}
              </h3>
            </Style.CardsHead>
            <Style.PropertyAdd
              style={{
                display: "flex",
                justifyContent: "space-between",
              }}>
              <div style={{ marginRight: "1rem" }}>
                <h3 style={{ fontFamily: "Poppins", fontSize: "20px" }}>
                  Add {module}
                </h3>
              </div>
              <Link
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                to={`/assets_new/attributes/${module}`}>
                <div
                  className="upload"
                  style={{ width: "28px", height: "28px" }}>
                  <img
                    src={addIcon1}
                    width={12}
                    height={12}
                    style={{ width: "16px", height: "16px" }}
                    alt="addicon"></img>
                </div>
                {/* <Style.AddBtn>
                  <img src={addIcon} />
               </Style.AddBtn>*/}
              </Link>
            </Style.PropertyAdd>
          </Style.SubCards>
          <Style.CardsMain
            style={{
              justifyContent: allProperties &&  allProperties.length > 0 ? "start" : "center",
              padding: "8px",
              gap: "1rem",
            }}>
            {/* {allProperties? allProperties.length >0: <p>No record found.</p>} */}
            {allProperties && allProperties.length > 0 ? (
              allProperties.map((item, index) => (
                <Style.Card
                  key={index}
                  //   onClick={() => fetchRoom(item)}

                  active={item.id == activeItem}>
                  <div style={{ overflow: "hidden", padding: "1rem", textAlign:"center" }}>
                    <Style.Img src={item.img} style={{width:"auto"}} />
                  </div>

                  <Style.PropertyCardDetails>
                    <div style={{ paddingTop: "1rem", overflow: "hidden" }}>
                      <Style.PropertyCardH3 style={{color:"black"}}>{item.name ? item.name : "N/A"} </Style.PropertyCardH3>
                    </div>
                    <div style={{ display: "flex" }}>
                      <div className="custom-field-alignments-icons">
                        <Button
                          type="link"
                          style={{ fontSize: "21px" }}
                          icon="edit"
                          onClick={(e) => {
                            handleEdit(e, item, "property");
                          }}></Button>
                      </div>
                      <div className="custom-field-alignments-icons">
                        <Button
                          type="link"
                          style={{ fontSize: "21px" }}
                          icon="eye"
                          onClick={(e) => {
                            handleView(e, item);
                          }}
                          ></Button>
                      </div>

                      <div className="custom-field-alignments-icons">
                        <Button
                          type="link"
                          style={{ fontSize: "21px" }}
                          icon="delete"
                          onClick={(e) => {
                            handleDelete(e, item, "property");
                          }}></Button>
                      </div>
                    </div>
                  </Style.PropertyCardDetails>
                  <Style.Desc
                    style={{
                      paddingInline: "1rem",
                      borderBottom: "1px solid #F0F0F0",
                    }}>
                    <div
                      style={{
                        display: "flex",
                        width: "100%",
                        justifyContent: "space-between",
                        gap:"1rem"
                      }}>
                      <div style={{ display: "flex", flexDirection: "column",width:"50%" }}>
                        <div>
                          <p
                            style={{
                              fontFamily: "Poppins",
                              fontSize: "12px",
                              fontWeight: "400",
                              color: "#8B8D97",
                            }}>
                            {module==="Real Estate" ? "Rate of Return:" : "Account Type:"}
                          </p>
                        </div>
                        <div>
                          <p
                            style={{
                              fontWeight: "bold",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              color: "black",
                              fontFamily: "Poppins",
                              fontSize: "14px",
                              fontWeight: "500",
                            }}>
                            {module==="Real Estate" ? (item["Rate of Return"]
                              ? parseFloat(item["Rate of Return"]).toFixed(2) + "%"
                              : "N/A"): item["Account Type/Titled"]
                              ? capitalizeFirstLetter(item["Account Type/Titled"])
                              : "N/A"}
                          </p>
                        </div>
                      </div>
                      <div style={{ display: "flex", flexDirection: "column",width:"50%" }}>
                        <div>
                          <p
                            style={{
                              fontFamily: "Poppins",
                              fontSize: "12px",
                              fontWeight: "400",
                              color: "#8B8D97",
                            }}>
                            {item.module === "Investment Portfolio"
                              ? "Account Number:"
                              : item.module === "Real Estate"
                              ? "Purchase Date:"
                              : "Type:"}   
                          </p>
                        </div>
                        <div>
                          <p
                            style={{
                              fontWeight: "bold",
                              color: "black",
                              fontFamily: "Poppins",
                              fontSize: "14px",
                              fontWeight: "500",
                            }}>
                            {item.module==="Investment Portfolio" ?
                            (item["Account Number"] ? item["Account Number"] : "N/A")
                            : item.module === "Real Estate" ?  (item["Cost Basis Date"] ? moment(item["Cost Basis Date"]).format("MMM D, YYYY") : "N/A")
                            :
                            (item.type ? item.type : "N/A")
                            }
                          </p>
                        </div>
                      </div>
                    </div>
                    <div style={{ display: "flex", width: "100%", justifyContent:"space-between",gap:"1rem" }}>
                    <div style={{ display: "flex", flexDirection: "column",width:"50%" }}>
                      <div>
                        <p
                          style={{
                            fontFamily: "Poppins",
                            fontSize: "12px",
                            fontWeight: "400",
                            color: "#8B8D97",
                          }}>
                          {item.module==="Investment Portfolio" ? "Total Gain/Loss:" :  item.module === "Real Estate" ? "Purchase Price:" : "SubType:"}   
                        </p>
                      </div>
                      <div>
                        <p
                          style={{
                            fontWeight: "bold",
                            color: "black",
                            //   paddingLeft: "0.4rem",
                            fontFamily: "Poppins",
                            fontSize: "14px",
                            fontWeight: "500",
                          }}>
                          {item.module==="Investment Portfolio" ?
                             (item["Cost Basis"] ? moneyFormatter(item["Cost Basis"]) : "N/A")
                            : item.module === "Real Estate" ?  (item["Cost Basis"] ? moneyFormatter(item["Cost Basis"]) : "N/A")
                            :
                            (item.subType ? item.subType : "N/A")
                            }
                        </p>
                      </div>
                    </div>
                    {item.module==="Investment Portfolio" &&
                    <div style={{ display: "flex", flexDirection: "column",width:"50%" }}>
                    <div>
                      <p
                        style={{
                          fontFamily: "Poppins",
                          fontSize: "12px",
                          fontWeight: "400",
                          color: "#8B8D97",
                        }}>
                        {item.module==="Investment Portfolio" ? "Held Where" : ""}   
                      </p>
                    </div>
                    <div>
                      <p
                        style={{
                          fontWeight: "bold",
                          color: "black",
                          //   paddingLeft: "0.4rem",
                          fontFamily: "Poppins",
                          fontSize: "14px",
                          fontWeight: "500",
                        }}>
                        {item["Held Where"] ? item["Held Where"] : "N/A"}
                      </p>
                    </div>
                    </div>
                    }
                    </div>
                  </Style.Desc>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      paddingInline: "1rem",
                    }}>
                    <div>
                      <p
                        style={{
                          fontFamily: "Poppins",
                          fontSize: "12px",
                          fontWeight: "400",
                          color: "#8B8D97",
                          marginTop:"8px"
                        }}>
                        {item.module==="Investment Portfolio" ? "Total Account Value:" : item.module === "Real Estate" ? "Value:" :"Total:"}  
                      </p>
                    </div>
                    <div>
                      <p
                        style={{
                          fontWeight: "bold",
                          color: "black",
                          // paddingLeft: "0.4rem",
                          fontFamily: "Poppins",
                          fontSize: "14px",
                          fontWeight: "500",
                        }}>
                        {item.module==="Investment Portfolio" ?
                          (item["Monetary Value"] ? moneyFormatter(item["Monetary Value"]) : "N/A")
                         : item.module === "Real Estate" ?  (item["Monetary Value"] ? moneyFormatter(item["Monetary Value"]) : "N/A")
                         :
                         (item["Monetary Value"] ? moneyFormatter(item["Monetary Value"]) : "$ 0")
                         }
                      </p>
                    </div>
                  </div>
                  {/*<Style.Counts1>
                    <div style={{ width: "100%", display: "flex" }}>
                      <Style.Sign1>
                        <h3 style={{ color: "white", paddingTop: "0.5rem" }}>
                          $
                        </h3>
                      </Style.Sign1>
                      <div
                        style={{
                          width: "90%",
                          display: "flex",
                          justifyContent: "center",
                          paddingRight: "1rem",
                        }}
                      >
                        <h3
                          style={{
                            paddingTop: "0.5rem",
                            color: "#39b54a",
                            fontWeight: "bold",
                          }}
                        >
                          {moneyFormatter(item.total)}
                        </h3>
                      </div>
                    </div>
                        </Style.Counts1>*/}
                </Style.Card>
              ))
            ) : (
              <h1 style={{marginTop:"6rem"}}>No Items to Display for this Asset Allocation.</h1>
            )}
          </Style.CardsMain>
        </Style.Cards>
      </Style.Main>
      <div>
        <Modal
          width={"58rem"}
          visible={isModal}
          footer={null}
          // onCancel={handleModalCancel}
          // style={{ width: showUpdateItem && "fit-content" }}
          bodyStyle={{
            overflowY: "auto",
            maxHeight: "calc(100vh - 200px)",
          }}></Modal>
      </div>
      <NewLoader isLoading={isLoading}/>
      {/*<Loader isLoading={isLoading} /> */}
    </div>
  );
}

export default AssetListing;
